module.exports = __webpack_public_path__ + "img/bullet.622f0735.svg";